import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'licenze',
    initialState: {
        lista_licenze: [],
        statusAction: 'READY',
    },
    actions: ['GET_LICENSES'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.GET_LICENSES_SUCCESS:
                return {
                    ...state,
                    lista_licenze: action.payload.lista_licenze
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getLicensesRequest: (codiceUtente) => ({
            type: types.GET_LICENSES_REQUEST,
            payload: { codiceUtente },
        }),
        getLicensesSuccess: ({ lista_licenze }) => ({
            type: types.GET_LICENSES_SUCCESS,
            payload: { lista_licenze },
        }),
        getLicensesFailed: error => ({ type: types.GET_LICENSES_FAILED, error: true, payload: { error } }),
    }),
});
